 // SWAP MENU BUTTON TO ADD ANOTHER SLING

(() => {
  const DESKTOP_LABEL_SEL = '.create-your-sling__label';
  const MOBILE_LABEL_SEL  = '.create-your-sling__label-mobile';

  const DEFAULT_TEXT = 'CREATE YOUR SLING';
  const ANOTHER_TEXT = 'CREATE ANOTHER SLING';

  // Identify a "sling in cart" by product handle or title keywords
  // Adjust these to be as strict as you want.
  const SLING_HANDLE = 'create-your-own-bc-sling';
  const SLING_TITLE_MATCH = /bc sling|create your own bc sling/i;

  function setLabels(text) {
    document.querySelectorAll(DESKTOP_LABEL_SEL).forEach(el => (el.textContent = text));
    document.querySelectorAll(MOBILE_LABEL_SEL).forEach(el => (el.textContent = text));
  }

  async function run() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;

      const cart = await res.json();

      const hasSling = (cart.items || []).some(item => {
        const handle = item.handle || '';
        const title = item.product_title || item.title || '';
        return handle === SLING_HANDLE || SLING_TITLE_MATCH.test(title);
      });

      setLabels(hasSling ? ANOTHER_TEXT : DEFAULT_TEXT);
    } catch (e) {
      // Fail silently
    }
  }

  // Set default immediately, then update when cart loads
  setLabels(DEFAULT_TEXT);

  // Run on load (works on cart page + anywhere else these links appear)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();



 // ADD A BUTTON TO CART ITEM ADD ANOTHER SLING

(() => {
  const CONFIG_URL = 'https://configurator.bonecollector.com/';
  const SLING_HANDLE = 'create-your-own-bc-sling';
  const SLING_TITLE_MATCH = /create your own bc sling|bc sling/i;

  // Where to insert the button within each sling line item row
  const DETAILS_SEL = '.cart-item__details';

  const BTN_CLASS = 'bc-add-another-sling';
  const BTN_HTML = `
    <a class="${BTN_CLASS} button button--secondary"
       href="${CONFIG_URL}"  rel="noopener">
      Create Another Sling
    </a>
  `;

  function isSlingItem(item) {
    const handle = item.handle || '';
    const title = item.product_title || item.title || '';
    return handle === SLING_HANDLE || SLING_TITLE_MATCH.test(title);
  }

  function insertButtonIntoRowByIndex(lineIndex) {
    // Dawn cart rows are 1-indexed in ids like CartItem-1
    const row = document.getElementById(`CartItem-${lineIndex}`);
    if (!row) return;

    const details = row.querySelector(DETAILS_SEL);
    if (!details) return;

    // Avoid duplicates
    if (details.querySelector(`.${BTN_CLASS}`)) return;

    // Insert after the product title link if possible, else append to details
    const titleLink = details.querySelector('.cart-item__name');
    if (titleLink && titleLink.parentNode === details) {
      titleLink.insertAdjacentHTML('afterend', BTN_HTML);
    } else {
      details.insertAdjacentHTML('beforeend', BTN_HTML);
    }
  }

  async function run() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();

      const slingLineIndexes = [];
      (cart.items || []).forEach((item, idx) => {
        if (isSlingItem(item)) slingLineIndexes.push(idx + 1);
      });

      if (!slingLineIndexes.length) return;

      slingLineIndexes.forEach(insertButtonIntoRowByIndex);
    } catch (e) {
      // fail silently
    }
  }

  // Run on load; also rerun after Dawn updates the cart via AJAX (optional but helpful)
  const onReady = () => run();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  // Optional: re-run when cart sections re-render
  document.addEventListener('cart:refresh', run);
  document.addEventListener('cart:updated', run);
})();







// MAIN ADD A SLING TO CART SCRIPT
(() => {
  if (window.location.pathname !== '/cart') return;

  const qs = new URLSearchParams(window.location.search);
  if (qs.get('configurator') !== 'true') return;

  const PRODUCT_HANDLE = 'create-your-own-bc-sling';

  const safeTextFromHtml = (s) => {
    if (!s) return '';
    const div = document.createElement('div');
    div.innerHTML = String(s);
    return (div.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const extractImgSrc = (s) => {
    if (!s) return '';
    const match = String(s).match(/src\s*=\s*["']([^"']+)["']/i);
    return match ? match[1] : '';
  };

  const looksLikeUnresolvedMergeTag = (s) => {
    return typeof s === 'string' && s.includes('{') && s.includes('}');
  };

  const normalizeKey = (s) => {
    return safeTextFromHtml(s).toUpperCase().replace(/\s+/g, ' ').trim();
  };

  const toSize = (rawWidth) => {
    const k = normalizeKey(rawWidth);
    if (k.includes('TRADITIONAL')) return 'Traditional';
    if (k.includes('SLIM')) return 'Slim';
    return '';
  };

  const toColor = (rawColor) => {
    const k = normalizeKey(rawColor);
    if (k.includes('LIGHT BROWN')) return 'Light Brown';
    if (k.includes('CHESTNUT')) return 'Chestnut';
    if (k.includes('TWO TONE') || k.includes('TWO-TONE')) return 'Two Tone';
    if (k.includes('BLACK')) return 'Black';
    return '';
  };

  const toSwivel = (rawSwivel) => {
    const k = normalizeKey(rawSwivel);

    if (!k) return 'No';

    // Explicit NO cases first
    if (
      k.includes('NO SWIVEL') ||
      k.includes('NO SWIVEL MOUNT') ||
      k === 'NO' ||
      k.endsWith('|0') ||
      k.includes('|0')
    ) {
      return 'No';
    }

    // Explicit YES cases
    if (
      k.includes('ADD A SWIVEL MOUNT') ||
      k.includes('ADD 2 SWIVEL MOUNTS') ||
      k.includes('+$10') ||
      k.includes('$10') ||
      k.endsWith('|10') ||
      k.includes('|10') ||
      k === 'YES'
    ) {
      return 'Yes';
    }

    return 'No';
  };

  const raw = {
    width: qs.get('width') || '',
    color: qs.get('color') || '',
    top_logo: qs.get('top_logo') || '',
    bottom_logo: qs.get('bottom_logo') || '',
    border: qs.get('border') || '',
    thumb_hole: qs.get('thumb_hole') || '',
    text: qs.get('text') || '',
    swivel_mount: qs.get('swivel_mount') || ''
  };

  const cleanVals = {
    width: safeTextFromHtml(raw.width),
    color: safeTextFromHtml(raw.color),
    top_logo: safeTextFromHtml(raw.top_logo),
    bottom_logo: safeTextFromHtml(raw.bottom_logo),
    border: safeTextFromHtml(raw.border),
    thumb_hole: safeTextFromHtml(raw.thumb_hole),
    text: (raw.text || '').trim(),
    swivel_mount: safeTextFromHtml(raw.swivel_mount)
  };

  if (looksLikeUnresolvedMergeTag(cleanVals.thumb_hole)) {
    cleanVals.thumb_hole = '';
  }

  const sizeValue = toSize(raw.width);
  const colorValue = toColor(raw.color);
  const swivelValue = toSwivel(raw.swivel_mount);

  const properties = {};

  const addProp = (label, value) => {
    if (!value) return;
    properties[label] = value;
  };

  const addImgProp = (label, rawHtml) => {
    const src = extractImgSrc(rawHtml);
    if (src) properties['_' + label + ' Image'] = src;
  };

  addProp('Width', cleanVals.width);
  addImgProp('Width', raw.width);

  addProp('Color', cleanVals.color);
  addImgProp('Color', raw.color);

  addProp('Top Logo', cleanVals.top_logo);
  addImgProp('Top Logo', raw.top_logo);

  addProp('Bottom Logo', cleanVals.bottom_logo);
  addImgProp('Bottom Logo', raw.bottom_logo);

  addProp('Border', cleanVals.border);
  addImgProp('Border', raw.border);

  addProp('Thumb Hole', cleanVals.thumb_hole);
  addProp('Sling Text', cleanVals.text);

  fetch('/products/' + PRODUCT_HANDLE + '.js', {
    headers: { Accept: 'application/json' }
  })
    .then((r) => {
      if (!r.ok) throw new Error('Failed to load product JSON');
      return r.json();
    })
    .then((product) => {
      const variant = (product.variants || []).find((v) => {
        return (
          v.option1 === sizeValue &&
          v.option2 === colorValue &&
          v.option3 === swivelValue
        );
      });

      if (!variant) {
        console.error('[BC Sling] No match found', {
          sizeValue,
          colorValue,
          swivelValue,
          rawSwivel: raw.swivel_mount,
          cleanSwivel: cleanVals.swivel_mount,
          variants: (product.variants || []).map((v) => ({
            id: v.id,
            title: v.title,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3
          }))
        });
        throw new Error('No exact matching sling variant found');
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          properties: properties
        })
      });
    })
    .then((r) => {
      if (!r.ok) return r.json().then((e) => Promise.reject(e));
      return r.json();
    })
    .then(() => {
      window.location.href = '/cart';
    })
    .catch((err) => {
      console.error('[BC Sling Configurator] Add failed:', err);
    });
})();